import * as List from "list.js";

const Coty = {
  el: {
    search: document.querySelector("[data-action='search-company']"),
    selectSector: document.querySelector("[data-action='select-company-sector']"),
    selectSize: document.querySelector("[data-action='select-company-size']"),
    sorters: document.querySelectorAll(".company-of-the-year__table [data-sort]"),
    wrapper: document.querySelector(".company-of-the-year"),
  },

  selectedSize: "S",
  selectedSector: "",

  companiesList: null,
  winnersList: null,

  init: () => {
    if (!Coty.el.wrapper) return;

    Coty.companiesList = new List(Coty.el.wrapper, {
      valueNames: [
        {
          data: [
            "size",
            "sector",
            "name",
            "averagegrade",
            "management",
            "moral",
            "salary",
            "workingconditions",
            "flexibility",
            "independence",
            "businessimage",
            "satisfaction",
            "equality",
            "responserate",
            "ranking",
            "topfive",
          ],
        },
      ],
      listClass: "company-of-the-year__table-body",
    });

    Coty.winnersList = new List(Coty.el.wrapper, {
      valueNames: [{ data: ["size"] }],
      listClass: "company-top5__boxes",
    });

    Coty.el.search.addEventListener("keyup", Coty.searchResults);
    Coty.el.selectSize.addEventListener("change", Coty.filterBySize);
    Coty.el.selectSector.addEventListener("change", Coty.filterBySector);

    Coty.el.sorters.forEach(sorter => {
      sorter.addEventListener("click", Coty.sortResults);
    });

    Coty.renderResults();
  },

  filterBySize: event => {
    Coty.selectedSize = event.target.value;
    Coty.renderResults();
  },

  filterBySector: event => {
    Coty.selectedSector = event.target.value;
    Coty.renderResults();
  },

  renderResults: () => {
    Coty.companiesList.filter(item => {
      if (
        item.values().size === Coty.selectedSize &&
        (item.values().sector === Coty.selectedSector || Coty.selectedSector === "")
      ) {
        return true;
      }
      return false;
    });
    Coty.winnersList.filter(item => {
      if (item.values().size === Coty.selectedSize) {
        return true;
      }
      return false;
    });
  },

  searchResults: event => {
    if (event.target.value.length > 1) {
      Coty.companiesList.search(event.target.value, ["name"]);
    } else {
      Coty.companiesList.search();
    }
  },

  sortResults: event => {
    Coty.el.sorters.forEach(sorter => sorter.removeAttribute("data-sort-active"));
    event.target.setAttribute("data-sort-active", "");

    const sorter = event.target.getAttribute("data-sort");
    console.log(sorter);

    Coty.companiesList.sort(sorter, {
      order: sorter === "name"  ? "asc" : "desc",
      alphabet: "0123456789АаÁáBbDdÐðEeÉéFfGgHhIiÍíJjKkLlMmNnOoÓóPpRrSsTtUuÚúVvXxYyÝýÞþÆæÖö",
    });
  },
};

export default Coty;
